import React from 'react';
import T from 'prop-types';

import Modal from './Modal';
import Button from './Buttons/Button';

const ModalDownload = ({ downloadUrl, title, open, onClose, onDownload }) => (
  <Modal
    open={open}
    size="xs"
    cardSize="lg"
    shouldCloseOnOverlayClick={false}
    closeButtonIconClass="hicon-close"
    modalClassName="download-report-modal"
    onClose={() => onClose(false)}
  >
    <h3 className="h3 download-report-modal__title">{title}</h3>
    <div className="download-report-modal__body" />
    <div className="download-report-modal__footer">
      <Button
        size="lg"
        href={downloadUrl}
        target="_blank"
        onClick={() => onDownload && onDownload()}
      >
        Download
      </Button>
      <Button size="lg" variant="secondary" onClick={() => onClose(false)}>
        Cancel
      </Button>
    </div>
  </Modal>
);

ModalDownload.propTypes = {
  downloadUrl: T.string.isRequired,
  title: T.string.isRequired,
  open: T.bool.isRequired,
  onClose: T.func.isRequired,
  onDownload: T.func,
};

export default ModalDownload;
